import Vue from 'vue';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

Bugsnag.start({
    apiKey:'b1a833550155b79a15951b3079c5a1dc',
    plugins: [new BugsnagPluginVue(Vue)]
});
